import React, { useEffect } from "react";

// import redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../features/store";
import { auditPlanCloseAction } from "../features/sliceReducer/interactionReducer";

//import component

//import material-UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Modal,
  TextField,
  Paper,
  Typography,
  InputLabel,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { IPSchedule } from "../models/IPSchedule";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { addAuditPlanAction } from "../features/sliceReducer/projectReducer";

//material-UI-Style

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "1200px",
      height: "840px",
      overflowY: "auto",

      backgroundColor: theme.palette.background.paper,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3, 6, 3),
    },

    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      margin: "0 auto",
    },
    labelAlign: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "8px 0 8px 12px",

      "& > label": {
        width: "8%",
        fontWeight: "bold",
      },
      "& > div": {
        flexGrow: 1,
      },
    },
    modalTitle: {
      marginBottom: " 30px",
      textAlign: "center",
      fontWeight: "bold",
    },
  })
);

interface AuditPlanModelProps {
  projectUID: number;
  schedule: IPSchedule;
}

const AuditPlanModal = (props: AuditPlanModelProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<IPSchedule>();

  useEffect(() => {
    reset(props.schedule);
  }, [props]);

  const { auditPlanToggle } = useSelector(
    (state: RootState) => state.interaction
  );

  const onSubmit: SubmitHandler<IPSchedule> = (data: IPSchedule) => {
    console.log("this UUID : " + data.uuid);
    dispatch(addAuditPlanAction(data));
    reset();
    dispatch(auditPlanCloseAction());
    console.log(data);
  };
  return (
    <React.Fragment>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={auditPlanToggle}
        onClose={() => {
          dispatch(auditPlanCloseAction());
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={auditPlanToggle}>
          <Box component={Paper} className={classes.paper}>
            <Typography
              className={classes.modalTitle}
              variant="h5"
              component="h5"
            >
              세부감사계획 및 대상 입력
            </Typography>
            <form className={classes.container}>
              <Box className={classes.labelAlign}>
                <InputLabel>일시 :</InputLabel>
                <Controller
                  name="date"
                  control={control}
                  defaultValue={props.schedule.date}
                  render={({ field }) => (
                    <TextField
                      {...register("date", { required: "일시를 입력해주세요" })}
                      // id="date"
                      {...field}
                      label="일시"
                      multiline
                      required
                      variant="outlined"
                      margin="normal"
                      error={errors.date ? true : false}
                    />
                  )}
                />
              </Box>
              <input type="hidden" defaultValue={props.schedule.uuid} {...register("uuid")} />
              <Box pl="100px">
                <Typography variant="inherit" color="secondary">
                  {errors.date?.message}
                </Typography>
              </Box>
              {/* //note SmokingScully 주석처리 2022-02-19 */}
              {/* <Box className={classes.labelAlign}>
                <InputLabel>대상부서 :</InputLabel>
                <TextField
                  {...register("department")}
                  id="department"
                  label="대상부서"
                  multiline
                  // rows={3}
                  variant="outlined"
                  margin="normal"
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>감사내용 :</InputLabel>
                <TextField
                  {...register("contents")}
                  id="contents"
                  label="감사내용"
                  multiline
                  // rows={3}
                  variant="outlined"
                  margin="normal"
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>비고 :</InputLabel>
                <TextField
                  {...register("note")}
                  id="note"
                  label="비고"
                  multiline
                  // rows={3}
                  variant="outlined"
                  margin="normal"
                />
              </Box> */}
              <Box mt={4} mb={4} textAlign="center">
                <Button
                  style={{ width: "120px", height: "48px" }}
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                >
                  정보 저장
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
};

export default AuditPlanModal;
